import { useFragmentsViewCapture } from '@app/modules/fragments/hooks/useFragmentsViewCapture';
import { buildLoggerStreamUrl } from '@app/modules/logger/screens/stream/helpers/build-logger-stream-url';
import { DateTimeStr, toTimestamp } from '@mi-front/core';
import HighlightAltIcon from '@mui/icons-material/HighlightAlt';
import { defineMessage, useIntl } from 'react-intl';
import { FragmentLoggerActionButton } from './FragmentLoggerActionButton';

const goToStreamWithSelectionMessage = defineMessage({
  id: 'fragments.view.metadata.goToStreamWithSelection',
  defaultMessage: 'Selección',
});

type FragmentGoToStreamWithSelectionActionProps = {
  stationSlug: string;
  fragmentFrom: DateTimeStr;
  fragmentTo: DateTimeStr;
};

/**
 * Opens the logger stream with the whole fragment selected.
 */
export function FragmentGoToStreamWithSelectionAction({
  stationSlug,
  fragmentFrom,
  fragmentTo,
}: FragmentGoToStreamWithSelectionActionProps) {
  const { $t } = useIntl();
  const fragmentsCapture = useFragmentsViewCapture();
  const selectionFrom = toTimestamp(fragmentFrom);
  const selectionTo = toTimestamp(fragmentTo);
  const loggerStreamUrl = buildLoggerStreamUrl(stationSlug, {
    selection: { from: selectionFrom, to: selectionTo },
  });
  const handleClick = () => {
    fragmentsCapture.goToStreamWithSelection({
      stationSlug,
      fragmentFrom,
      fragmentTo,
    });
  };

  return (
    <FragmentLoggerActionButton
      to={loggerStreamUrl}
      onClick={handleClick}
      startIcon={<HighlightAltIcon fontSize="small" />}
    >
      {$t(goToStreamWithSelectionMessage)}
    </FragmentLoggerActionButton>
  );
}
